import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { IProductDataV2 } from '@df/catalog/product/product';
import { PriceComponent } from '@df/ui/price/price.component';
import { Product } from '../product.decorator';
/**
 * Displays product price
 */
@Component({
    selector: 'product-view-price',
    templateUrl: './product-view-price.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [CommonModule, PriceComponent]
})
export class ProductViewPriceComponent {
    /**
     * Default image
     */
    @Input()
    product?: Product;

    get pricePrefix(): string | undefined {
        return this.product?.pricePrefix;
    }

    get setPrice(){
        const qtyIncrements = (<IProductDataV2>this.product?.data)?.qty_increments || 1
        return qtyIncrements > 1 ? (this.product?.price || 0)*(qtyIncrements) : undefined;
    }
}
